import { css, styled } from "styled-components";

import { APP_GUTTER, APP_WIDTH } from "styles/theme";
import { LG_WIDTH, MD_WIDTH } from "styles/theme/layout";

type SectionProps = {
  $hasBottomBorder?: boolean;
  $isFullWidthOnMobile?: boolean;
};

export const FullWidthSection = styled.div`
  @media (max-width: ${APP_WIDTH}px) {
    padding-left: ${APP_GUTTER}px;
    padding-right: ${APP_GUTTER}px;
  }
  @media (max-width: ${LG_WIDTH}px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
`;

export const Section = styled.section<SectionProps>`
  width: 100%;
  margin: 0 auto;

  ul,
  ol {
    list-style: initial;
  }

  @media (max-width: ${LG_WIDTH}px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  @media (min-width: ${LG_WIDTH}px) {
    padding-left: ${APP_GUTTER}px;
    padding-right: ${APP_GUTTER}px;
  }

  ${(props) =>
    props.$isFullWidthOnMobile &&
    css`
      @media (max-width: ${MD_WIDTH}px) {
        padding-left: 0;
        padding-right: 0;
      }
    `}

  ${({ $hasBottomBorder, theme }) =>
    $hasBottomBorder &&
    `
    border-bottom: 1px solid ${theme.colors.sectionBorder};
  `}
`;

export const SectionDivider = styled.section``;
